/** Height of the app's bottom bar on phones (MobileBottomNav); kept apart so it imports nothing. */
export const MOBILE_NAV_HEIGHT = 60;
